/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Tag, Text } from 'bold-ui'
import { green, red } from 'bold-ui/lib/styles/colors'
import theme from 'config/theme'
import { StatusAvaliadoEnum } from 'graphql/types.generated'
import { useMemo } from 'react'
import { formatDate } from 'util/date/formatDate'

interface StatusAvaliacaoTagProps {
  status: StatusAvaliadoEnum
  dataAvaliacao: LocalDate
  usePrimaryColors: boolean
}

export default function StatusAvaliacaoTag(props: StatusAvaliacaoTagProps) {
  const { status, dataAvaliacao, usePrimaryColors } = props
  const statusIsPresente = status === StatusAvaliadoEnum.PRESENTE
  const classes = useMemo(() => createStyles(statusIsPresente), [statusIsPresente])
  const styleToUse = usePrimaryColors ? classes.neutro : classes.presenteAusente

  return (
    <Tag type='info' icon={statusIsPresente ? 'checkCircleFilled' : 'timesFilled'} style={styleToUse}>
      <Text fontWeight='bold' style={styleToUse}>
        {`${status.capitalize()} - `}
        <Text fontWeight='normal' style={styleToUse}>
          {formatDate(dataAvaliacao)}
        </Text>
      </Text>
    </Tag>
  )
}

const createStyles = (statusIsPresente: boolean) => ({
  neutro: css`
    background: ${theme.pallete.status.info.background};
    color: ${theme.pallete.status.info.main};
    border-color: ${theme.pallete.status.info.main};
  `,
  presenteAusente: css`
    color: ${(statusIsPresente ? green : red).c40};
    background-color: ${(statusIsPresente ? green : red).c90};
  `,
})
